import { defineMessages } from 'react-intl';

export const messages: {
	hiddenSectionTitle: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	hiddenSectionTitle: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.hidden-section-title',
		description: 'Title to display at the top of a hidden section being displayed for preview',
		defaultMessage: 'Hidden section',
	},
});
